import {
  AcceptedCardsRow,
  FormError,
  SectionTitle,
  Stack,
  Wrapper,
} from './PaymentMethodForm.styles';
import type { PaymentMethodFormLabels, PaymentMethodFormProps } from './PaymentMethodForm.types';

const DEFAULT_LABELS: Required<PaymentMethodFormLabels> = {
  sectionTitle: 'Payment method',
  acceptedCardsAriaLabel: 'Accepted cards',
};

export function PaymentMethodForm({
  children,
  acceptedCards,
  showHeader = true,
  formError,
  labels,
}: PaymentMethodFormProps) {
  const merged = { ...DEFAULT_LABELS, ...labels };

  return (
    <Wrapper data-testid="payment-method-form">
      {showHeader && <SectionTitle>{merged.sectionTitle}</SectionTitle>}

      <Stack>
        {children}

        {formError && <FormError role="alert">{formError}</FormError>}

        {acceptedCards && (
          <AcceptedCardsRow aria-label={merged.acceptedCardsAriaLabel}>
            {acceptedCards}
          </AcceptedCardsRow>
        )}
      </Stack>
    </Wrapper>
  );
}
